/** @jsxImportSource @emotion/react */
import css from '@emotion/css/macro'
import colors from '@sportninja/common/constants/appColors'
import type { InputNumberProps } from 'antd'
import { InputNumber } from 'antd'
import Text from '../Text'
import { paragraphMedium, weightRegular } from 'src/components/css'
import { ErrorLabel } from '../ErrorLabel'
import { SerializedStyles } from '@emotion/react'

type CurrencyInputProps = {
  label: string
  value: number
  disabled?: boolean
  onChange: InputNumberProps['onChange']
  min?: number
  fieldErrors?: string[]
  customError?: string
  name: string
  selectStyle?: SerializedStyles
}

const CurrencyInput = ({
  label,
  value,
  disabled,
  onChange,
  min = 0,
  fieldErrors = [],
  customError = '',
  name,
  selectStyle,
}: CurrencyInputProps) => {
  return (
    <div
      css={css`
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: ${label ? '8px' : '0'};
        flex: 1 0 0;
        align-self: stretch;
        width: 100%;
      `}
    >
      <Text
        variant='paragraphSmall'
        color={colors.WHITE}
        weight='regular'
        style={`
          align-self: stretch;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        `}
      >
        {label}
      </Text>
      <InputNumber
        status={fieldErrors[name] || fieldErrors?.includes(name) ? 'error' : ''}
        name={name}
        min={min}
        disabled={disabled}
        defaultValue={value}
        value={value}
        formatter={(v) => `$${v}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
        parser={(v) => (v ? parseFloat(v.replace(/\$\s?|(,*)/g, '')) : 0)}
        onChange={(v) => {
          if (onChange) {
            onChange(typeof v === 'number' ? v : 0)
          }
        }}
        css={[
          css`
            height: 40px !important;
            border-radius: 8px;
            border: 1px solid ${colors.SECONDARY_100};
            background: ${colors.SECONDARY_200};
            width: 100%;
            .ant-input-number-input {
              display: flex !important;
              padding: 6px 8px !important;
              ${paragraphMedium}
              ${weightRegular}
            }
            .ant-input-number-handler-up {
              border-top-right-radius: 8px !important;
            }
            .ant-input-number-handler-down {
              border-bottom-right-radius: 8px !important;
            }
            .ant-input-number-handler-wrap {
              border-start-end-radius: 8px !important;
              border-end-end-radius: 8px !important;
            }
            ${disabled &&
            css`
              color: ${colors.NEUTRAL_100};
            `}
            ${!disabled &&
            css`
              color: ${colors.WHITE};
            `}
          `,
          selectStyle,
        ]}
      />
      <ErrorLabel
        fieldErrors={fieldErrors}
        customError={customError}
        name={name}
      />
    </div>
  )
}

export default CurrencyInput
